let apiUrl: string = '';

if (process.env.NEXT_PUBLIC_ENVIRONMENT === 'dev') {
  apiUrl = process.env.NEXT_PUBLIC_LOCAL_ENDPOINT || '';
} else {
  apiUrl = process.env.NEXT_PUBLIC_PRODUCTION_ENDPOINT || '';
}

// Normalize to ensure exactly one trailing slash and no double slashes when composing URLs.
if (apiUrl) {
  apiUrl = apiUrl.replace(/\/+$/, '/');
}

// Fallback: detect host at runtime when env vars are not set
if (!apiUrl) {
  try {
    if (typeof window !== 'undefined') {
      const host = window.location.hostname;
      if (/entelligence\.ai$/i.test(host)) {
        apiUrl = 'https://entelligence.ddbrief.com/';
      } else if (host.endsWith('.cloudfront.net')) {
        apiUrl = `https://${host}/backend/`;
      }
    }
  } catch {
    // ignore — fall through to localhost default
  }
}

// Dev ergonomics: local loopback default only in non-production builds so mis-set env on Vercel
// cannot silently point prod at 127.0.0.1.
if (
  !apiUrl &&
  process.env.NEXT_PUBLIC_ENVIRONMENT === 'dev' &&
  process.env.NODE_ENV !== 'production'
) {
  apiUrl = 'http://127.0.0.1:8000/';
}
if (apiUrl) {
  apiUrl = apiUrl.replace(/\/+$/, '/');
}

// Fail loudly if no endpoint is configured
if (!apiUrl) {
  const errMsg =
    'CRITICAL: API endpoint not configured. Set NEXT_PUBLIC_ENVIRONMENT to "dev" or "prod", ' +
    'and ensure NEXT_PUBLIC_LOCAL_ENDPOINT (dev) or NEXT_PUBLIC_PRODUCTION_ENDPOINT (prod) is set.';
  console.error(errMsg);
  if (typeof window !== 'undefined') {
    // Runtime error visible to operators
    throw new Error(errMsg);
  } else {
    // Build-time error for SSR/SSG
    throw new Error(errMsg);
  }
}

// Guard against mixed-content: HTTPS page cannot call HTTP API
if (typeof window !== 'undefined') {
  const pageProtocol = window.location.protocol;
  const apiProtocol = apiUrl.startsWith('https://') ? 'https:' : 'http:';
  if (pageProtocol === 'https:' && apiProtocol === 'http:') {
    const mixedContentErr = `Mixed content blocked: page is ${pageProtocol} but API is ${apiProtocol}. Update NEXT_PUBLIC_PRODUCTION_ENDPOINT to use https://.`;
    console.error(mixedContentErr);
    throw new Error(mixedContentErr);
  }
}

export default apiUrl;
export { apiUrl as API_URL };
